import { Mesh, ParametricBufferGeometry } from 'three';
import BlobMaterial from './material';


export default class Blob extends Mesh {
  constructor() {
    const geo = new ParametricBufferGeometry((x, y, target) => {
      target.set(0, 0, 0);
    }, 100, 100);

    geo.removeAttribute('position');
    geo.removeAttribute('normal');

    super(geo, new BlobMaterial());

    this.frustumCulled = false;
  }
}
